import { ReactNode, useEffect, useState } from "react";
import { useErrorBoundary } from "react-error-boundary";
import { ConfigResponse } from "interfaces/resourceService";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { getCustomerCode } from "app/utils";
import { getConfig, saveToLog } from "api/axios";
import {
  selectResourcesLoaded,
  setResourceServices,
} from "slices/resourceService";
import Loader from "components/features/Loader/Loader";

interface ConfigLoaderProps {
  children: ReactNode;
}

const ConfigLoader = ({ children }: ConfigLoaderProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const { showBoundary } = useErrorBoundary();
  const resourcesLoaded = useAppSelector(selectResourcesLoaded);
  const dispatch = useAppDispatch();

  useEffect(() => {
    getConfig({
      initReq: "",
      t: new Date().getTime(),
      CLIENT_CODE: getCustomerCode().toUpperCase(),
    })
      .then((response: ConfigResponse) => {
        dispatch(setResourceServices(response));
      })
      .catch((error) => {
        showBoundary(error)
        saveToLog(error);
      });
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setIsLoading(!resourcesLoaded);
  }, [resourcesLoaded]);

  if (isLoading) {
    // You can render a loading indicator here
    return <>{<Loader />}</>;
  }

  return <>{children}</>;
};

export default ConfigLoader;
